export default function OgPreview() {
  return (
    <div
      style={{
        width: "1200px",
        height: "630px",
        background: "#F7F7F6",
        position: "relative",
        overflow: "hidden",
        fontFamily: "'Cormorant Garamond', serif",
      }}
    >
      <div
        style={{
          position: "absolute",
          inset: "48px",
          border: "1px solid #E5E5E5",
        }}
      />
      <div
        style={{
          position: "absolute",
          top: "80px",
          left: "80px",
          fontFamily: "'Manrope', sans-serif",
          fontSize: "13px",
          letterSpacing: "0.22em",
          textTransform: "uppercase",
          color: "#525252",
          fontWeight: 600,
        }}
      >
        Saran Gandhi · Independent Consultant
      </div>

      <h1
        style={{
          position: "absolute",
          top: "180px",
          left: "80px",
          right: "80px",
          fontFamily: "'Cormorant Garamond', serif",
          fontWeight: 300,
          fontSize: "108px",
          lineHeight: 0.95,
          letterSpacing: "-0.02em",
          color: "#0A0A0A",
          margin: 0,
        }}
      >
        Scaling businesses
        <br />
        without scaling
        <br />
        <em style={{ color: "#273228" }}>headcount.</em>
      </h1>

      <div
        style={{
          position: "absolute",
          bottom: "80px",
          left: "80px",
          right: "80px",
          display: "flex",
          justifyContent: "space-between",
          alignItems: "flex-end",
          fontFamily: "'Manrope', sans-serif",
        }}
      >
        <div
          style={{
            fontSize: "13px",
            letterSpacing: "0.22em",
            textTransform: "uppercase",
            color: "#525252",
            fontWeight: 600,
            maxWidth: "440px",
            lineHeight: 1.6,
          }}
        >
          Strategy · Operations · AI-led redesign
        </div>
        <div
          style={{
            fontFamily: "'Cormorant Garamond', serif",
            fontSize: "32px",
            fontWeight: 300,
            color: "#0A0A0A",
          }}
        >
          sarangandhi.com
        </div>
      </div>

      <div
        style={{
          position: "absolute",
          right: "-60px",
          bottom: "-80px",
          fontFamily: "'Cormorant Garamond', serif",
          fontStyle: "italic",
          fontWeight: 300,
          fontSize: "320px",
          lineHeight: 0.8,
          color: "#EFEFEF",
          pointerEvents: "none",
          userSelect: "none",
        }}
      >
        00
      </div>
    </div>
  );
}
